import * as Yup from "yup";

export const getSchemaErrors = (
  schema: Yup.Schema,
  data: unknown
): Record<string, string> | undefined => {
  try {
    schema.validateSync(data, { abortEarly: false });
    return undefined;
  } catch (err: unknown) {
    if (err instanceof Yup.ValidationError) {
      return err.inner.reduce(
        (agg, e) => (e.path ? { ...agg, [e.path]: e.message } : agg),
        {}
      );
    } else {
      throw err;
    }
  }
};

function isDate(candidate: unknown): candidate is Date {
  return typeof (candidate as any)?.getMonth === "function";
}

export const transformDateForYup = (
  value: Date,
  originalValue: unknown
): Date | undefined => {
  if (isDate(originalValue)) {
    return originalValue;
  }
  if (!originalValue) {
    return undefined;
  }
  return value;
};
